export default __webpack_public_path__ + "static/media/Enero2024(1440x600).c9ec69f6.webp";